import { TabsWithVersion } from '@/components/core/TabsWithVersion';
import { rollCompetitionTabsOptions } from './options';
import { useRollCompetition } from '@/hooks/roll-point/useRollCompetition';
import { RollCompetitionContentTabsProps } from './props';

export default function RollCompeititonContentTabs({
  isLoading,
}: RollCompetitionContentTabsProps) {
  const { currentTab, onTabChange } = useRollCompetition();

  return (
    <TabsWithVersion
      i18nNamespace="common"
      tabs={rollCompetitionTabsOptions}
      currentTab={currentTab}
      setTab={onTabChange}
      disabled={isLoading}
      invertColors
    />
  );
}
